import { defineMessages } from 'react-intl';

export const projectTimelineBlocksMessages = defineMessages({
  thoughtProcess: {
    defaultMessage: 'Thought process',
    id: 'rxPDwNAz+D',
    description: 'Summary label for expandable thinking disclosure',
  },
  skipped: {
    defaultMessage: 'Skipped',
    id: 'YlF5XBERHZ',
    description: 'Clarification answer when the user dismissed the question',
  },
  answered: {
    defaultMessage: 'Answered',
    id: 'H7AcwSwDq/',
    description: 'Clarification answer fallback when no text was captured',
  },
  answersHeading: {
    defaultMessage: 'Answers',
    id: '7hP+bFUUaj',
    description: 'Heading for resolved clarification summary card',
  },
  clarificationQuestionFallback: {
    defaultMessage: 'a clarification question',
    id: '043mnHKokr',
    description: 'Fallback label when a clarification question text is missing',
  },
  allDone: {
    defaultMessage: 'All done.',
    id: '98W33VPMDw',
    description: 'Final step-complete marker label',
  },
  allDoneWithOutcome: {
    defaultMessage: '<label>All done.</label> <outcomeStyle>{outcome}</outcomeStyle>',
    id: 'P5Mwk68UKK',
    description: 'Final step-complete marker with its outcome',
  },
  done: {
    defaultMessage: 'Done',
    id: 'YVxcrsywDj',
    description: 'Intermediate step-complete marker without outcome text',
  },
  doneWithOutcome: {
    defaultMessage: '<label>Done:</label> <outcomeStyle>{outcome}</outcomeStyle>',
    id: 'o7q8CavcRm',
    description: 'Intermediate step-complete marker with its outcome',
  },
});
